import { Tooltip } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { toastError, toastSuccess, toastWarning } from '@components/Toast';

import UploadImage from '@features/designTool/components/UploadImage';

import { productWiseGroupDocument } from '@store/actions/DesignToolAction';

import ApiClient from '@lib/apiClient';

import { checkAnyUserType, getShortName, isValidFile } from '@utils/Util';

import { BASE_URL } from '@/constants/constant';

import VirtualTryOnSidebar from '@/features/designTool/components/VirtualTryOnSidebar';
import AiModelCard from '@/features/designTool/components/AiModelCard';

const Presentation = ({ setLoader }) => {
	const designToolCommentStore = useSelector((store) => store.designToolCommentStore);
	const designToolStore = useSelector((store) => store.designToolStore);
	const [psdItems, setPsdItems] = useState(['']);
	const isAdminOrPhotographer = checkAnyUserType(['ADMIN', 'PHOTOGRAPHY']);
	const dispatch = useDispatch();
	const { id } = useParams();
	const [isOpenSidebar, setIsOpenSidebar] = useState(false);

	useEffect(() => {
		dispatch(productWiseGroupDocument(id));
		setLoader(false);
	}, [id]);

	const renderFabricList = () => {
		if (designToolStore?.fabrics?.length > 1) {
			return designToolStore?.fabrics?.map((item, index) => {
				index++;
				if (index < 3) {
					return (
						<>
							<p key={`fabric_${index}`} className="regular-14 gray_dark_01">
								{`Fabric ${index}`}: {item?.fabricDetailsForPresentation}
							</p>
							<p key={`gsm_${index}`} className="regular-14 gray_dark_01">
								Weight: {item.weight}
							</p>
							<br />
						</>
					);
				}
			});
		} else if (designToolStore.fabrics) {
			return (
				<>
					<p className="regular-14 gray_dark_01">
						Fabric: {designToolStore.fabrics[0]?.fabricDetailsForPresentation}
					</p>
					<p className="regular-14 gray_dark_01">Weight: {designToolStore.fabrics[0]?.weight}</p>
				</>
			);
		}
	};

	const onUploadImage = async (image) => {
		setLoader(true);
		await ApiClient.POST(`${BASE_URL}/product/${id}/upload-bulk-presentation`, image, '', true)
			.then(() => {
				dispatch(productWiseGroupDocument(id));
				setLoader(false);
			})
			.catch(({ response }) => {
				setLoader(false);
				toastError(response.data.message);
			});
	};

	const onFileUpload = (e) => {
		let files = [];
		let modifiedFileList = [];
		files = [...e.target.files];
		let invalidFiles = files.filter((item) => item.size > 1000000);
		if (invalidFiles.length > 0) {
			toastError('Each image size should be less than 1mb');
			return;
		}
		if (files.length !== 0 && invalidFiles.length === 0) {
			files.forEach((file) => {
				if (file) {
					if (isValidFile(file, 'PRESENTATION_UPLOAD')) {
						let data = {
							name: file?.name,
							docMimeType: file?.type,
							documentType: 'PRESENTATION_UPLOAD',
							base64Str: ''
						};
						let reader = new FileReader();
						reader.readAsDataURL(file);
						reader.onload = () => {
							data.base64Str = reader.result;
							modifiedFileList.push(data);
						};
						reader.onerror = function (error) {
							toastError(error);
						};
					}
				}
			});
			setTimeout(() => {
				if (modifiedFileList?.length > 0) {
					onUploadImage(modifiedFileList);
				}
			}, 100);
		}
	};

	const onPsdFilesUpload = (e) => {
		setLoader(true);
		let files = e.target.files;
		let totalSize = 0;

		for (let i = 0; i < files.length; i++) {
			let file = files[i];
			totalSize += file.size;
			if (totalSize > 100 * 1024 * 1024) {
				setLoader(false);
				toastWarning('Maximum file upload size is 100MB');
				return;
			}
		}

		ApiClient.UPLOAD_MULTIPLE_FILE(
			'uploadPresentaionPsdFile',
			Array.from(e.target.files),
			`${id}`,
			'json',
			'files'
		)
			.then(() => {
				setLoader(false);
				toastSuccess('Successfully added');
				getPsdFiles();
			})
			.catch((error) => {
				setLoader(false);
				toastError(error.response.data.message);
			});
	};

	const getPsdFiles = () => {
		ApiClient.GET('getPresentaionPsdFiles', id)
			.then((response) => {
				const data = response.data;
				setPsdItems(data);
			})
			.catch((response) => {
				toastError(response.message);
			});
	};

	const handleToggleSidebar = () => {
		setIsOpenSidebar(!isOpenSidebar);
	};

	const renderPsdFiles = () => {
		return psdItems?.map((item) => {
			return (
				<div className="single-upload" key={item.id}>
					<Tooltip title={item?.name} placement="top" arrow>
						<p
							className="regular-14 gray_dark_01 cursor-pointer"
							onClick={() => window.open(item?.docUrl, '_blank')}
						>
							{getShortName(item?.name, 12)}
						</p>
					</Tooltip>
					<div className="more-dropdown dropdown show">
						<button
							className="button text-only"
							type="button"
							id="moreInfo"
							data-toggle="dropdown"
							aria-expanded="true"
						>
							<img
								src={`${process.env.PUBLIC_URL}/icons/more_icon.svg`}
								alt="more"
								className="mr-1"
							/>
						</button>
						<ul
							className="dropdown-menu dropdown-menu-right shadow-lg"
							role="menu"
							aria-labelledby="moreInfo"
							x-placement="bottom-end"
						>
							<li>
								<span onClick={() => window.open(item?.docUrl, '_blank')}>Download</span>
							</li>
							<li>
								<span className="red" onClick={() => removePsd(item?.id)}>
									Delete
								</span>
							</li>
						</ul>
					</div>
				</div>
			);
		});
	};

	const removePsd = async (docId) => {
		setLoader(true);
		try {
			await ApiClient.DELETE('removePresentaionPsdFile', '', `${docId}`);
			setLoader(false);
			toastSuccess('Successfully removed');
			getPsdFiles();
		} catch (error) {
			setLoader(false);
			if (error.response && error.response.data && error.response.data.message) {
				toastError(error.response.data.message);
			} else {
				toastError('Request was unsuccessful.');
			}
		}
	};

	const removeImage = async (docId) => {
		setLoader(true);
		await ApiClient.DELETE('deleteProductDocument', '', `${id}/${docId}`)
			.then(() => {
				dispatch(productWiseGroupDocument(id));
				setLoader(false);
			})
			.catch(({ response }) => {
				setLoader(false);
				toastError(response.data.message);
			});
	};

	useEffect(() => {
		getPsdFiles();
	}, []);

	const handleDownload = async (productRef, imageUrl) => {
		const response = await fetch(imageUrl);
		const blob = await response.blob();
		const url = window.URL.createObjectURL(blob);
		// get file extension from imageUrl
		let fileExtension = '.jpg';
		if (imageUrl) {
			if (imageUrl.toLowerCase().includes('.png')) {
				fileExtension = '.png';
			} else if (imageUrl.toLowerCase().includes('.jpg') || imageUrl.toLowerCase().includes('.jpeg')) {
				fileExtension = '.jpg';
			}
		}

		const a = document.createElement('a');
		a.href = url;
		a.download = `${productRef}${fileExtension}`;
		document.body.appendChild(a);
		a.click();
		a.remove();
		window.URL.revokeObjectURL(url);
	};

	return (
		<div className="dashboard-container presentation-container bg-white pb-4">
			<div className="presentations-tab">
				<div className="presentations-upload-image-container">
					<UploadImage
						document={designToolCommentStore?.documentResponse?.front}
						title="Front"
						docType="FRONT_IMAGE"
						removeImage={removeImage}
					/>
					<UploadImage
						document={designToolCommentStore?.documentResponse?.back}
						title="Back"
						docType="BACK_IMAGE"
						removeImage={removeImage}
					/>
					<UploadImage
						document={designToolCommentStore?.documentResponse?.fabric}
						title="Fabric"
						docType="FABRIC_IMAGE"
						removeImage={removeImage}
					/>
					<UploadImage
						document={designToolCommentStore?.documentResponse?.embellishment}
						title="Key Details"
						docType="EMBELLISHMENT"
						removeImage={removeImage}
					/>
					<AiModelCard
						onOpenSidebar={handleToggleSidebar}
						hasEditPermission={isAdminOrPhotographer}
						imageUrl={designToolCommentStore?.virtualTryOnDocResponse?.docUrl}
						onDownload={() =>
							handleDownload(
								designToolStore?.referenceNumber,
								designToolCommentStore?.virtualTryOnDocResponse?.docUrl
							)
						}
					/>
				</div>
				<div
					className={`upload-presentaion-and-psd mt-3 d-flex align-items-center ${
						isAdminOrPhotographer ? '' : 'justify-content-center'
					}`}
				>
					<div className="all-presentaion mr-3">
						<div className="inline-upload">
							<label htmlFor="multipleUpload">
								<img src={`${process.env.PUBLIC_URL}/icons/upload-dark.svg`} /> Upload
								Presentation
							</label>
							<input
								type="file"
								className="file-upload"
								id="multipleUpload"
								name="image"
								onClick={(e) => (e.target.value = null)}
								onChange={(e) => onFileUpload(e)}
								accept="image/*"
								multiple={true}
							/>
						</div>
					</div>

					{isAdminOrPhotographer && (
						<div className="d-flex align-items-center">
							<div className="upload-psd-btn">
								<div className="inline-upload">
									<label htmlFor="psdUpload">
										<img src={`${process.env.PUBLIC_URL}/icons/upload-dark.svg`} /> Upload
										PSD
									</label>
									<input
										type="file"
										className="file-upload"
										id="psdUpload"
										name="image"
										onClick={(e) => (e.target.value = null)}
										onChange={(e) => onPsdFilesUpload(e)}
										accept=".psd"
										multiple={true}
									/>
								</div>
							</div>

							<div className="all-uploaded-psd gap-2">{renderPsdFiles()}</div>
						</div>
					)}
				</div>
			</div>
			<div className="presentation-view-container">
				<div className="style-and-logo">
					<p className="regular-14 gray_dark_01 m-0">STYLE: {designToolStore?.referenceNumber}</p>
				</div>
				<div className="images-view-section">
					<div className="one-third full-photo">
						{designToolCommentStore?.documentResponse?.front?.docUrl && (
							<img src={designToolCommentStore?.documentResponse?.front?.docUrl} alt="front" />
						)}
					</div>
					<div className="one-third full-photo">
						{designToolCommentStore?.documentResponse?.back?.docUrl && (
							<img src={designToolCommentStore?.documentResponse?.back?.docUrl} alt="front" />
						)}
					</div>
					<div className="one-third fabric-photo">
						<div className="single-fabric">
							{designToolCommentStore?.documentResponse?.fabric?.docUrl && (
								<img
									src={designToolCommentStore?.documentResponse?.fabric?.docUrl}
									alt="front"
								/>
							)}
						</div>
						<div className="single-fabric">
							{designToolCommentStore?.documentResponse?.embellishment?.docUrl && (
								<img
									src={designToolCommentStore?.documentResponse?.embellishment?.docUrl}
									alt="front"
								/>
							)}
						</div>
						<p className="regular-14 gray_dark_01">Item: {designToolStore?.name}</p>
						{renderFabricList()}
					</div>
				</div>
				<div className="presentation-footer">
					<div className="left-border">
						<div className="border-full" />
					</div>
					<div className="right-logo">
						<img src={`${process.env.PUBLIC_URL}/icons/presentation-bottom-logo.svg`} alt="" />
					</div>
				</div>
				{isOpenSidebar && (
					<VirtualTryOnSidebar
						onClose={handleToggleSidebar}
						productId={id}
						frontImageUrl={designToolCommentStore?.documentResponse?.front?.docUrl}
						backImageUrl={designToolCommentStore?.documentResponse?.back?.docUrl}
						referenceName={designToolStore?.referenceNumber}
						productMarket={designToolStore?.productGroup}
						parentCatergory={designToolStore?.parentCatergory}
						onDownload={handleDownload}
					/>
				)}
			</div>
		</div>
	);
};

export default Presentation;
